
const F2FSelfReferralServiceAct = 2067;
const HybridTriageServiceAct = 2011;

const VitalityHealthStaffSchemeClient = 191405;
const VitalityHealthClient = 191404;
const VitalityHealthMSKPostOp = 89112;
const VitalityHealthNOC6 = 326729;
const VitalityHealthLiteMSK = 579491;

/**
 * This function is used to alter the web config for WR527.
 * It adds config that we don't currently have in the database, as 
 * it's very client specific.
 * @param {*} webConfig 
 * @returns 
 */
const wr527Fudges = webConfig => {

    const fudge = {
        AppointmentTypeRestrictions: [
            {
                ServiceActivityID: F2FSelfReferralServiceAct,
                IncludeAppointmentTypeIDs: []
            }
        ],
        InjuryRegionRestrictions: {
            MaxNumberOfInjuries: 3,
            Restrictions: [
                {
                    ServiceActivityID: F2FSelfReferralServiceAct,
                    MaxNumberOfInjuries: 1
                }
            ]
        },
        /* #2039: capture a Claim Number per injury region. The backend maps
        this to the case Reference Type. Held off until the 27/10/2026 release */
        CaptureInjuryClaimNumber: false,
        ServiceActivities: [
            {
                ClientPartyIDs: [
                    VitalityHealthClient,
                    VitalityHealthStaffSchemeClient,
                    VitalityHealthMSKPostOp,
                    VitalityHealthNOC6,
                    VitalityHealthLiteMSK
                ],
                ServiceActivityID: HybridTriageServiceAct,
                FriendlyName: "Hybrid Call"
            },
            {
                ClientPartyIDs: [
                    VitalityHealthClient,
                    VitalityHealthStaffSchemeClient,
                    VitalityHealthLiteMSK
                ],
                ServiceActivityID: F2FSelfReferralServiceAct,
                FriendlyName:
                    "F2F Treatment - only use where a member has already had a triage call by another physiotherapy provider"
            }
        ]
    };

    /*  put VitalityHealthLiteMSK at the end of the list WR-1188
        hideous fix but we don't use the client feature elsewhere so no point in implementing 
        a configurable ordering system */
    webConfig.Clients = webConfig.Clients.sort((a, b) => {
        if (a.ClientPartyID === VitalityHealthLiteMSK) {
            return 1; // VitalityHealthLiteMSK goes to the end
        }
        if (b.ClientPartyID === VitalityHealthLiteMSK) {
            return -1; // VitalityHealthLiteMSK goes to the end
        }
        return 0; // keep the order of other items
    });

    /* Flag that we need to WARN the referrer to check they 
    have selected the correct plan. This is because there is a cost 
    for the patient, associated with some plans.
    See  WR-1350. At some point we could add a client setting at the backend 
    and have this configurable per client, but we might well also want to set
    the text of the warning message on a per client basis. Note that 
    the referrer will consider the choice of client to be a choice of plan
    because different health cover plans will be mapped to different clients
    in our system. */
    webConfig.Clients.forEach(client => client.ShowWarning = 
        (client.ClientPartyID === VitalityHealthLiteMSK));

    return {
        ...webConfig,
        ...fudge,
        // Clear these as they would cause us to jump over the client and 
        // service activity selection
        ClientPartyID: null,
        fkClientPartyID: null,
        ServiceActivityId: null,
        fkServiceActivityId: null
    };
};

export default wr527Fudges;
